<ion-content>
  <ion-grid class="px-0 pt-0 pb-[5em]">
    <ion-row class="bg-[--primary-white] py-4">
      <ion-col class="flex items-center justify-center max-w-prose m-auto">
        <ion-icon
          name="chevron-back-outline"
          class="mx-2 text-lg bg-white p-2 rounded-lg hover:cursor-pointer shadow"
          (click)="goToAnalyse()"
        ></ion-icon>
        <ion-title class="p-0 sm:mr-8">
          <h1 class="m-0 xs:max-[350px]:!text-2xl">Nettleie&#173;analyse</h1>
        </ion-title>
      </ion-col>
    </ion-row>
    <ion-row class="max-w-prose m-auto">
      <ion-col>
        <p class="text-center mb-0 text-lg">
          {{ valgtAdresse }}
        </p>
        <p class="text-center mb-8">
          <strong>Din netteier</strong> {{ netteier || 'Ukjent' }}
        </p>

        @if (!loading) { @if (hasNoConfig) {
        <ion-row>
          <ion-col class="mx-2 mb-4">
            <div class="bg-[--primary-strong-100] px-4 py-1 rounded-lg">
              <p class="font-bold text-lg">Nettleieanalyse ikke tilgjengelig</p>
              <p>
                Noen få netteiere har ikke innført den nye trappetrinnsmodellen
                for nettleie. Dette ser ut til å gjelde for adressen du har
                valgt, og vi kan derfor ikke lage en nettleieanalyse for ditt
                forbruk.
              </p>
            </div>
          </ion-col>
        </ion-row>
        } @else {
        <ion-row>
          <ion-col class="mx-2">
            <p class="font-bold text-xl m-0">Dine døgnmakser</p>
            <p class="m-0">Grunnlag for kapasitetsleddet på nettleien</p>
            <p
              class="underline hover:cursor-pointer"
              (click)="showDaymaxInfo()"
            >
              <ion-icon name="information-circle-outline"></ion-icon>
              Hva er en døgnmaks?
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-row class="rounded-lg pb-2 oversikt">
              <ion-col>
                <p class="font-bold text-lg p-2 m-0">Oversikt</p>
                <div class="flex flex-col gap-2 mx-2">
                  <div
                    class="rounded-lg px-2 flex justify-between oversikt-item"
                  >
                    <p>
                      Kostnad (trinn {{ currentStep.limit }}-{{
                        currentStep.next_limit
                      }}
                      kWh)
                      <ion-icon
                        name="information-circle-outline"
                        class="hover:cursor-pointer"
                        (click)="showTrinnInfo = true"
                      ></ion-icon>
                    </p>

                    <ion-modal
                      [isOpen]="showTrinnInfo"
                      [backdropDismiss]="true"
                      (didDismiss)="showTrinnInfo = false"
                    >
                      <ng-template>
                        <ion-content>
                          <div class="modalClose">
                            <img
                              src="/assets/img/shared/close.svg"
                              (click)="closeModal()"
                            />
                          </div>
                          <p class="mb-0 text-lg">
                            <strong
                              >Oversikt over kapasitetsledd for
                              {{ netteier }}</strong
                            >
                          </p>
                          <p class="mt-0">
                            Ditt nåværende trinn er uthevet i tabellen.
                          </p>
                          <table
                            class="m-auto w-full text-center border-2 border-[--primary-white] mb-8"
                          >
                            <thead class="bg-[--primary-white]">
                              <tr>
                                <th><p class="my-2">Kapasitetsledd</p></th>
                                <th><p class="my-2">Kostnad/mnd</p></th>
                              </tr>
                            </thead>
                            <tbody>
                              @if (analyzedConsumption.steps) { @for (step of
                              analyzedConsumption.steps; track $index) {
                              <tr
                                class="py-2 border-b-2 border-[--primary-white]"
                                [class.bold]="
                                  step.step ===
                                  analyzedConsumption.current_step.step
                                "
                              >
                                <td>
                                  <p class="my-2">
                                    {{ step.limit }} - {{ step.next_limit }} kWh
                                  </p>
                                </td>
                                <td>
                                  <p class="my-2">
                                    {{ step.cost.toFixed(0) }} kr
                                  </p>
                                </td>
                              </tr>
                              } }
                            </tbody>
                          </table>
                          <div class="mx-4">
                            <p>
                              Kapasitetsleddet (også kalt fastleddet) i nettleia
                              bestemmes av gjennomsnittet av de tre høyeste
                              døgnmaksene i måneden. Døgnmaks er den
                              <strong>timen med høyest strømforbruk</strong> i
                              løpet av et døgn.
                            </p>
                            <p>
                              De tre timene hentes ikke fra samme døgn. Det
                              betyr at dersom du bruker mye strøm på et og samme
                              døgn er det kun den timen med høyest forbruk som
                              gjelder.
                            </p>
                          </div>
                        </ion-content>
                      </ng-template>
                    </ion-modal>

                    @if (!loading) {
                    <p>
                      <strong>
                        {{
                          errorAnalyse
                            ? 'Kunne ikke hente data'
                            : currentStep?.cost + ' kr'
                        }}
                      </strong>
                    </p>
                    } @else {
                    <ion-spinner class="my-auto" name="dots"></ion-spinner>
                    }
                  </div>
                  <div class="rounded-lg px-2 oversikt-item">
                    <div class="flex justify-between">
                      <p class="mb-0">Grunnlag</p>
                      @if (!loading) {
                      <p class="mb-0">
                        <strong>
                          {{
                            errorAnalyse
                              ? 'Kunne ikke hente data'
                              : analyzedConsumption?.avg_high_three
                                  .toFixed(2)
                                  .replace('.', ',') + ' kWh'
                          }}
                        </strong>
                      </p>
                      } @else {
                      <ion-spinner class="my-auto" name="dots"></ion-spinner>
                      }
                    </div>
                    <p class="text-sm mt-0">
                      Snitt av de 3 høyeste døgnmaksene
                    </p>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <div class="my-4">
              <app-box-wrapper
                [title]="isBeginningOfNewMonth ? 'Oppsummering' : 'Tiltak'"
                [hasError]="errorAnalyse || !analyzedConsumption?.result"
              >
                @if (isBeginningOfNewMonth) {
                <app-summary-nettleie
                  [analyzedConsumption]="analyzedConsumption"
                ></app-summary-nettleie>
                } @else {
                <div class="rounded-lg px-2 bg-white">
                  <app-nettleie-advisory
                    [analyzeNettleie]="analyzedConsumption"
                    [errorAnalyse]="errorAnalyse"
                  ></app-nettleie-advisory>
                </div>
                }
              </app-box-wrapper>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <app-box-wrapper title="Innsikt i døgnmakser">
              <div class="rounded-lg p-2 oversikt-item">
                <p class="mt-0">
                  🕵️ Når på døgnet og gjennom uka bruker du generelt mest strøm
                  samtidig?
                </p>
                <ion-button class="dark w-full" id="investigate">
                  Undersøk
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </ion-button>
              </div>
              <ion-modal [trigger]="'investigate'">
                <ng-template>
                  <ion-content>
                    <app-prediction-nettleie></app-prediction-nettleie>
                  </ion-content>
                </ng-template>
              </ion-modal>
            </app-box-wrapper>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="mx-2">
            <p><strong>Visning av dine døgnmakser</strong></p>
            <div class="p-1 rounded-lg">
              <ion-button
                class="w-1/2"
                (click)="changeActiveView('three')"
                [class.selected]="activeView === 'three'"
              >
                3 høyeste
              </ion-button>
              <ion-button
                class="w-1/2"
                (click)="changeActiveView('month')"
                [class.selected]="activeView === 'month'"
              >
                Måned
              </ion-button>
            </div>
            <div class="mb-4">
              @if (analyzedConsumption) { @if (activeView === 'month') {
              <app-daymax-graph
                [allDayMax]="allDayMax"
                [topThreeDayMax]="topThreeDayMax"
                [avg_high_three]="analyzedConsumption.avg_high_three"
                [steps]="allSteps"
                [currentStep]="currentStep"
                [activeView]="activeView"
              >
              </app-daymax-graph
              >} @else {
              <app-daymax-graph
                [allDayMax]="topThreeDayMax"
                [topThreeDayMax]="topThreeDayMax"
                [avg_high_three]="analyzedConsumption.avg_high_three"
                [steps]="allSteps"
                [currentStep]="currentStep"
                [activeView]="activeView"
              >
              </app-daymax-graph>
              }
              <ion-button
                (click)="toggleTableVisibility()"
                class="secondary cursor-pointer flex items-center gap-1 justify-center"
              >
                <strong>Vis i tabell</strong>
                @if (!showTable) {
                <ion-icon name="chevron-down-outline"></ion-icon>
                } @else {
                <ion-icon name="chevron-up-outline"></ion-icon>
                }
              </ion-button>
              @if (showTable) {
              <div>
                <p>
                  <strong>
                    {{
                      activeView === 'three'
                        ? 'De tre høyeste døgnmakser denne måned'
                        : 'Alle døgnmakser denne måned'
                    }}
                  </strong>
                </p>
                @if (activeView === 'three') {
                <app-daymax-table
                  [dayMaxes]="topThreeDayMax"
                ></app-daymax-table>
                } @else {
                <app-daymax-table
                  [dayMaxes]="allDayMax"
                  [highThree]="topThreeDayMax"
                ></app-daymax-table>
                }
              </div>
              } } @else {
              <ion-spinner name="dots"></ion-spinner>
              }
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <app-your-hours
              [analyzeNettleie]="analyzedConsumption"
              [errorAnalyse]="errorAnalyse"
            ></app-your-hours>
          </ion-col>
        </ion-row>

        } } @else {
        <ion-row>
          <ion-col class="mx-2 text-center">
            <ion-spinner name="dots"></ion-spinner>
          </ion-col>
        </ion-row>
        }

        <ion-row>
          <ion-col class="max-w-prose mx-3 my-8">
            <h3 class="mt-0">Spar penger på neste strømregning</h3>
            <p>
              Fastbeløpet/kapasitetsleddet på nettleien bestemmes av de 3 timene
              i måneden du bruker mest strøm. De tre timene hentes ikke fra
              samme døgn. Det betyr at dersom du bruker mye strøm på samme døgn,
              er det kun den timen med høyest forbruk som teller.
            </p>
            <p>
              Det vil også si at det skal bare noen få høye timer i måneden som
              gjør at du betaler mer enn du bør.
            </p>
            <p>
              Dette er normalt sett satt opp som en trappetrinnsmodell, hvor
              hvert trappetrinn koster mer enn det forrige.
            </p>
            <p>Mange netteiere har også lavere pris på kveld/natt og helg.</p>
            <p><strong>Vil du vite mer om nettleie?</strong></p>
            <ion-button
              href="https://www.ishavskraft.no/privat/sparetips/tabbene-du-gjor-med-nettleien-din?source=app"
            >
              Les mer om nettleie her
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
